import React from "react";
import PropTypes from "prop-types";
import Container from "../components/container";
import ImageLibpixel from "./image-libpixel.js";
import { _ } from "../utils/i18n";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  padding: 40px 0;
`;
const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
`;
const OneBox = styled.div`
  width: 100%;
  height: 280px;
  padding: 5px;
  @media (max-width: 440px) {
    height: 220px;
  }
`;
const TwoBox = styled.div`
  width: 100%;
  height: 220px;
  padding: 5px;
  @media (max-width: 440px) {
    height: 230px;
  }
`;
const ThreeBox = styled.div`
  width: 100%;
  height: 230px;
  padding: 5px;
  @media (max-width: 440px) {
    height: 230px;
  }
`;
const FourBox = styled.div`
  width: 100%;
  height: 270px;
  padding: 5px;
  @media (max-width: 440px) {
    height: 220px;
  }
`;
const StyledImage = styled(ImageLibpixel)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ImgGallery4 = ({ imgs }) => {
  return (
    <Container maxWidth="xl" disableGutters={true}>
      {imgs && (
        <Wrapper>
          <FlexContainer>
            <OneBox>
              <StyledImage src={imgs?.[0]?.img.sourceUrl} alt={_("kollage")} />
            </OneBox>
            <TwoBox>
              <StyledImage src={imgs?.[1]?.img.sourceUrl} alt={_("kollage")} />
            </TwoBox>
          </FlexContainer>
          <FlexContainer>
            <ThreeBox>
              <StyledImage src={imgs?.[2]?.img.sourceUrl} alt={_("kollage")} />
            </ThreeBox>
            <FourBox>
              <StyledImage src={imgs?.[3]?.img.sourceUrl} alt={_("kollage")} />
            </FourBox>
          </FlexContainer>
        </Wrapper>
      )}
    </Container>
  );
};

ImgGallery4.propTypes = {
  imgs: PropTypes.array,
};

ImgGallery4.defaultProps = {
  imgs: undefined,
};

export default ImgGallery4;
